module.exports = __webpack_public_path__ + "img/userSettings.bae8f137.svg";